export default {
  TIKTOK: {
    TITLE: 'Candidate Profile - wokap view',
    NAVBAR_TITLE_PREFIX: 'Job',
    PAGE_TITLE: '{{ offerTitle }} - wokap view',
    SEARCH_MODAL_TITLE: 'Type the candidate\'s name',
    TABLE_OCCUPATION_HEADER: 'Job title | Profession',
    TABLE_LOCATION_HEADER: 'Location',
    TABLE_APPLICATION_DATE_HEADER: 'Application date',
    LAST_CANDIDATE: {
      NO_MORE: 'No more candidates in {{stage}}.',
      WANT_TO_SEE: 'Want to see candidates in the next stage:',
      ACCESS_FROM_TABS: 'Access any stage from the tabs above.',
      VIEW_STAGE: 'View candidates – {{stage}}',
      VIEW_ALL: 'View all candidates',
      SUGGESTED_NO_MORE: 'No more Suggested candidates.',
      SUGGESTED_SEARCHING: 'wokap will keep looking for profiles that match your job.',
      SUGGESTED_MEANWHILE: 'In the meantime, review the candidates who have already applied.',
      SUGGESTED_WANT_FIRST_STAGE: 'Want to see candidates in the first stage:',
      SUGGESTED_VIEW_ENROLLED: 'Go to candidates – To review',
    },
    ACTIONS: {
      TITLE: 'Actions',
      TITLE_OFFER: ' Offer',
      PIN_IN_PANEL: 'Pin job to dashboard',
      UNPIN_IN_PANEL: 'Unpin job from dashboard',
      VIEW: 'View job',
      VIEW_EDIT: 'View / Edit job',
      SHARE: 'Share job',
      DUPLICATE: 'Duplicate job',
      EDIT_INTERVIEW: 'Create / Edit interview',
      PAUSE: 'Pause job',
      START: 'Resume job',
      END: 'Close job',
      DELETE: 'Delete job',
      // Custom tooltips for disabled states
      VIEW_EDIT_DISABLED_CLOSED: 'This job is closed. You can view it, but editing is disabled.',
      SHARE_DISABLED_PAUSED: 'This job is paused and cannot be shared.',
      SHARE_DISABLED_CLOSED: 'This job is closed and cannot be shared.',
      EDIT_INTERVIEW_DISABLED_CLOSED: 'This job is closed. You cannot create or edit interviews.',
      PAUSE_DISABLED_CLOSED: 'This job is closed and cannot be paused.',
      END_DISABLED_CLOSED: 'This job is already closed.',
      CREATE_INTERVIEW_TOOLTIP: 'Create interview',
      EDIT_INTERVIEW_TOOLTIP: 'Edit interview',
      PREVIEW_TOOLTIP: 'See how candidates will view this job in the app',
      // Ref: docs/libraries/Angular v18 Documentation.txt
      PREVIEW_MODAL_INFO: 'This is only a preview of how candidates will see your job in the wokap app. To try it yourself, download the wokap app.',
      EDIT_OFFER_TOOLTIP: 'Edit job information and settings',
      EDIT_OFFER_DISABLED_CLOSED: 'This job has been closed, its information can no longer be edited',
      LABEL: {
        PIN: 'Pin',
        UNPIN: 'Unpin',
        VIEW: 'View',
        VIEW_EDIT: 'View/Edit',
        SHARE: 'Share/Copy',
        COPY_LINK: 'Copy link',
        COPY_DATA: 'Copy data',
        COPY_QR: 'Copy QR',
        PREVIEW: 'Preview',
        EDIT_OFFER: 'Edit job',
        DUPLICATE: 'Duplicate',
        CREATE_INTERVIEW: 'Create interview',
        EDIT_INTERVIEW: 'Edit interview',
        PAUSE: 'Pause',
        START: 'Resume',
        END: 'Close',
        DELETE: 'Delete',
      },
    },
    VIEWS: {
      TITLE: 'View',
      TOOLTIP: 'Explore the 3 available views to browse candidates. Each offers different tools to evaluate and organize your pipeline',
      LIST: 'List',
      CARDS: 'Card',
      WOKAP: 'wokap',
      COMPACT: 'Compact view',
      EXPANDED: 'Expanded view',
      PANEL: 'Back to Jobs',
    },
    WOKAP_AI: { TOOLTIP: 'Find your ideal candidate in the wokap network' },
    ACTIONS_DISABLED: {
      NOT_ENROLLED: 'This candidate hasn\'t applied yet. Invite them to manage their pipeline.',
      NOT_ENROLLED_VIEW_PROFILE: 'This person hasn\'t applied to the offer yet. Invite them to view their full profile.',
      DISCARDED: 'This candidate has been rejected. They cannot be advanced to the next stage.',
      INTERVIEW_ANSWERED: 'This candidate has already completed the interview. To view it, scroll down to the «Interview» section.',
    },
    TABS: {
      FILTER: 'Filter candidates',
      SEARCH: 'Search candidates',
      KILLER_QUESTIONS: 'Screening questions',
      NAVIGATE: 'Browse wokap',
      SUGGESTED: 'Suggested candidates',
    },
    STATUS: {
      ALL: 'Applicants',
      ENROLLED: 'To review',
      TO_REVIEW: 'To review',
      PROCESS: 'Shortlisted',
      IN_PROGRESS: 'Shortlisted',
      PRESELECTED: 'Shortlisted',
      FINALISTS: 'Finalists',
      SELECTED: 'Finalists',
      DISCARDED: 'Rejected',
      SUGGESTED: 'Suggested',
      UNKNOWN: 'Unknown stage',
    },
    OFFER: 'Job',
    CANDIDATE_NAME: 'Name',
    LOCATION: 'Location',
    APPLICATION: 'Application',
    OCCUPATION: 'Job title | Profession',
    APPLICATION_DATE: 'Applied on',
    STATUS_LABEL: 'Stage',
    RATING: 'Rating',
    MATCH_TITLE: 'AI Match level (beta)',
    MATCH_DISCLAIMER1: 'Based on the info provided by the candidate when applying.',
    MATCH_DISCLAIMER1_5: 'The match score is just an estimate. It depends on the job requirements and the details the candidate put in.',
    MATCH_DISCLAIMER2: 'Errors can happen. Double-check the info before making any decisions.',
    MATCH_DISCLAIMER3: 'See our ',
    MATCH_DISCLAIMER3_LINK: 'Cookie Preferences.',
    SHARE_DISABLE: 'This candidate is already enrolled in this job. No need to invite them again.',
    SHARE_ENABLE: 'Invite this person to apply for the role. Once they do, you can manage their pipeline.',
    SHARE_ALREADY_SENT: 'You or someone from your company has already invited this person to apply for the job. When they accept the invitation, you can manage their pipeline.',
    REQUIREMENTS_TITLE: 'Qualifications, Skills & Language',
    COMPACT_VIEW: '📋 Compact view',
    EXPANDED_VIEW: '📖 Expanded view',
    MINIMUM_REQUIREMENTS: 'Minimum qualifications',
    DESIRED_REQUIREMENTS: 'Preferred qualifications',
    HARD_SKILLS: 'Hard skills',
    SOFT_SKILLS: 'Soft skills',
    SOFT_SKILLS_PREVIEW: 'Leadership, Communication...',
    TOOLS: 'Other skills',
    TOOLS_PREVIEW: 'Other skills...',
    LANGUAGES: 'Languages',
    NO_LANGUAGES: '{{ name }} has not registered any language.',
    LANGUAGE_NAMES: {
      ES: 'Spanish',
      EN: 'English',
      FR: 'French',
      DE: 'German',
      PT: 'Portuguese',
      PO: 'Portuguese',
      IT: 'Italian',
      ZH: 'Chinese (Mandarin)',
      JA: 'Japanese',
      AR: 'Arabic',
      RU: 'Russian',
      KO: 'Korean',
      NL: 'Dutch',
      SV: 'Swedish',
      NO: 'Norwegian',
      DA: 'Danish',
      FI: 'Finnish',
      PL: 'Polish',
      TR: 'Turkish',
      HI: 'Hindi',
      BN: 'Bengali',
      CA: 'Catalan',
      EU: 'Basque',
      GL: 'Galician',
      RO: 'Romanian',
      UK: 'Ukrainian',
      EL: 'Greek',
      CS: 'Czech',
      HU: 'Hungarian',
      HR: 'Croatian',
      SK: 'Slovak',
      SL: 'Slovenian',
      SR: 'Serbian',
      BS: 'Bosnian',
      BG: 'Bulgarian',
      LT: 'Lithuanian',
      LV: 'Latvian',
      ET: 'Estonian',
      HE: 'Hebrew',
      FA: 'Persian',
      UR: 'Urdu',
      VI: 'Vietnamese',
      TH: 'Thai',
      ID: 'Indonesian',
      MS: 'Malay',
      SW: 'Swahili',
      OTHER: 'Other',
    },
    LANGUAGE_PROFICIENCY: {
      NATIVE: 'Native',
      FLUENT: 'Fluent',
      ADVANCED: 'Advanced',
      UPPER_INTERMEDIATE: 'Upper intermediate',
      INTERMEDIATE: 'Intermediate',
      LOWER_INTERMEDIATE: 'Lower intermediate',
      ELEMENTARY: 'Elementary',
      BEGINNER: 'Beginner',
      BASIC: 'Basic',
      A1: 'A1 - Beginner',
      A2: 'A2 - Elementary',
      B1: 'B1 - Intermediate',
      B2: 'B2 - Upper intermediate',
      C1: 'C1 - Advanced',
      C2: 'C2 - Mastery',
    },
    CV_CURRICULUM: 'CV / Curriculum',
    VIEW_CV: 'View',
    DOWNLOAD_CV: 'Download',
    INTERVIEW_SECTION: 'Interview & Direct Questions',
    INTERVIEW: 'Interview',
    INTERVIEW_QUESTION_NUMBER: 'Interview',
    DIRECT_QUESTIONS: 'Direct Questions',
    QUESTION_NUMBER: 'Direct Question',
    VIDEOS: 'videos',
    ANSWERS: 'answers',
    CANDIDATE_INFO: 'Intro, Education, Experience & Resume',
    SECTIONS_AVAILABLE: 'available sections',
    PRESENTATION: 'Presentation',
    EDUCATION: 'Education',
    EXPERIENCE: 'Experience',
    NO_REQUIREMENTS: 'No minimum qualifications specified.',
    NO_DESIRED_REQUIREMENTS: 'No preferred qualifications for this role.',
    NO_HARD_SKILLS: '{{ name }} has not registered any hard skills.',
    NO_SOFT_SKILLS: '{{ name }} has not registered any soft skills.',
    NO_TOOLS: '{{ name }} has not registered any other skills.',
    NO_CV: 'No resume available.',
    NO_INTERVIEW_VIDEOS: 'No interview videos available.',
    SKIPPED: 'Question not answered by candidate',
    SKIPPED_PLURAL: 'no answers',
    NO_SPECIFIC_QUESTIONS: 'No direct questions answered.',
    NO_PRESENTATION: 'No intro video available.',
    NO_EXPERIENCE: 'No experience listed.',
    NO_EDUCATION: 'No education listed.',
    DISCARD_REASON: 'Discard reason:',
    HISTORY: 'History',
    NO_HISTORY: 'No history events.',
    NEXT: 'Next candidate',
    NO_NEXT: 'No more candidates in this stage, switch tabs to see other candidates.',
    PREVIOUS: 'Previous candidate',
    NO_PREVIOUS: 'No more candidates in this stage, switch tabs to see other candidates.',
    EMPTY_STATE: {
      ENROLLED_MOUSE_OVER: 'No more candidates for this job.',
      NO_CANDIDATES: {
        TITLE: 'No candidates have applied to this job yet.',
        PUBLISHED_SUBTITLE: 'Your job just went live and has no applicants yet. As candidates apply, you\'ll see them here.',
        MEANWHILE_SUGGESTED: 'In the meantime, explore the "Suggested" tab.',
        EMAIL_NOTIFICATION: 'We\'ll notify you by email when there are 5 applicants so you can review them.',
        MESSAGE: '',
        BUTTON: 'Back to Jobs',
      },
      ALL: {
        TITLE: 'No candidates found.',
        MESSAGE: 'There are no candidates in this stage.',
      },
      ENROLLED: {
        TITLE: 'No candidates to review.',
        MESSAGE: 'There are no candidates in this stage.',
      },
      IN_PROGRESS: {
        TITLE: 'No shortlisted candidates.',
        MESSAGE: 'There are no candidates in this stage.',
      },
      SELECTED: {
        TITLE: 'No finalist candidates.',
        MESSAGE: 'There are no candidates in this stage.',
      },
      DISCARDED: {
        TITLE: 'No rejected candidates.',
        MESSAGE: 'No rejected candidates found for this job.',
      },
      SUGGESTED: {
        TITLE: 'No suggested candidates.',
        MESSAGE: 'No suggested candidates found for this job.',
      },
      DEFAULT: {
        TITLE: 'No candidates available.',
        MESSAGE: 'There are no candidates in this stage.',
      },
      VIEW_ALL: 'View all candidates',
      GO_TO_SUGGESTED: 'View suggested candidates',
    },
  },
};
